export const formatNumber = (value, maximumFractionDigits = 2) => {
  if (isNaN(value) || value === null) {
    return ''
  }

  return value.toLocaleString('id-ID', { maximumFractionDigits })
}
